import { render } from "./UiSelect.vue?vue&type=template&id=091bcbbf"
import script from "./UiSelect.vue?vue&type=script&lang=js"
export * from "./UiSelect.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__